module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img_6.54bfbcdd.png";